
import Vue from "vue";
import {CustomViewTab} from "@/utils/tabs/custom-view-tab";
import {UserConfigService} from "@/services";
import AppCustomTabEdit from "@/components/view-editor/NewCustomTab.vue";

export default Vue.extend({
	data(){
		return {
			items: [] as CustomViewTab[],
			editItem: new CustomViewTab(),
			showCustomTabEdit: false
		};
	},
	props: {
		section: Boolean,
		browseName: {
			type: String
		},
		browseId: {
			type: Number
		}
	},
	computed: {
		title():string{
			if (this.section) return this.$ct("extensions.tabs").toString();
			return this.$ct("add-custom-tabs-to",{name: this.browseName}).toString();
		}
	},
	methods: {
		createNew(){
			this.editItem = new CustomViewTab();
			this.items?.push(this.editItem);
			this.showCustomTabEdit = true;
		},
		async onSave(){
			this.items = this.items.map((c: CustomViewTab) =>
				c.uid === this.editItem.uid ? this.editItem : c
			);
			await this.updateSettings();
		},
		async updateSettings(){
			let t = UserConfigService.getCustomViewTabs() as any;
			t["Browse"+this.browseId] = this.items;
			await UserConfigService.setCustomTabSettings(t);
			this.showCustomTabEdit=false;
		},
		async deleteTab(item:CustomViewTab){
			let confirm = await this.$wf.confirm(this.$ct("delete-tab"),
				this.$t("common.yes"), this.$t("common.no"), this.$t("common.warning"), "warning");
			if (!confirm) {
				return;
			}
			if(!this.items) return;
			this.items = this.items.filter(c => c.uid !== item.uid);
			this.updateSettings();
		},
		editClicked(item:CustomViewTab){
			this.editItem = item;
			this.showCustomTabEdit=true;
		}
	},
	created(){
		this.items = UserConfigService.getCustomViewTabsForBrowse(this.browseId) || [];
	},
	components: {
		AppCustomTabEdit
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
